import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import i18next from 'i18next';
import styles from './JobseekerProfile.module.css';
import EditSkill from '../../../components/UI/Common/EditSkill/EditSkill.js';
import EditRoleBasedSkill from '../../../components/UI/Common/EditRoleBasedSkill/EditRoleBasedSkill.js';
import Certificates from '../../../components/UI/Common/Certificates/Certificates.js';
import EditPortfolio from '../../../components/UI/Common/EditPortfolio/EditPortfolio.js';
import EditEducation from '../../../components/UI/Common/EditEducation/EditEducation.js';
import JobPreferences from '../../../components/UI/Common/JobPreferences/JobPreferences.js';
import ProfileSideBar from '../../../components/UI/Common/ProfileSideBar/ProfileSideBar';
import AboutMeSection from '../../../components/UI/Common/AboutMeSection/AboutMeSection.js';
import CompleteProfile from '../../../components/UI/Common/CompleteProfile/CompleteProfile';
import EditOccupations from '../../../components/UI/Common/EditOccupations/EditOccupations.js';
import GetVerifiedNotice from '../../../components/UI/Common/GetVerifiedNotice/GetVerifiedNotice.js';
import PersonalInformation from '../../../components/UI/Common/PersonalInformation/PersonalInformation.js';
import EditWorkExperience from '../../../components/UI/Common/EditWorkExperience/EditWorkExperience.js';
import EditResumeAndCoverLetter from '../../../components/UI/Common/EditResumeAndCoverLetter/EditResumeAndCoverLetter.js';
import JobseekerProfileEmployerView from '../ProfileEmloyerView/JobseekerProfile.js';
import { getUser } from '../../../services/userService';
import { getTimeAgo } from '../../../utils/formatHelpers';
import { calculateProfileCompletion } from '../../../components/UI/Common/CalculateCompleteProfile/CalculateCompleteProfile.js';
import {
    Certificate,
    Contact,
    Folder,
    Idea,
    Mortarboard,
    Navigation,
    Profile,
    TaskDone,
    WorkHistory
} from '../../../assets/images/icons/index.jsx';
import ContactDetail from '../../../components/UI/Common/ContactDetail/ContactDetail.js';
import Account from '../../../components/UI/Common/Account/Account.js';

function JobseekerProfile() {
    const { t } = useTranslation();
    const { slug } = useParams();
    const user = useSelector(state => state.user);
    const skills = useSelector((state) => state.user.skills);
    const location = useLocation();
    const currentLanguage = i18next.language;
    const [jobseeker, setJobseeker] = useState(null);
    const [completionPercentage, setCompletionPercentage] = useState(0); // state to track profile completion
    const getUserData = (slug) => {
        getUser('jobseeker', slug)
            .then((response) => {
                response.languages = response.languages.map((language) => {
                    return {
                        id: slug + '-' + language.languageCode,
                        languageCode: language.languageCode,
                        level: language.level
                    };
                });
                response.education = response.education.map((diploma) => {
                    return {
                        id: diploma.id,
                        diploma: {
                            name: diploma.diploma
                        },
                        education_title: diploma?.education_title,
                        institution: diploma.institution,
                        startDate: diploma.start,
                        endDate: diploma.end
                    };
                });
                response.skills = response.skills.map((skill) => {
                    if (skills.length > 0) {
                        let skillData = skills?.filter((e) => e.value == skill.skill_code)[0]
                        return {
                            id: slug + '-skill-' + skill.skill_code,
                            code: currentLanguage === "en" ? skillData.labelen : skillData.labelar,
                            skillLevel: skill.skillLevel
                        };
                    }
                    else {
                        return {
                            id: slug + '-skill-' + skill.skill_code,
                            skillLevel: skill.skillLevel,
                            code: skill.skill_code
                        };
                    }
                });
                response.age = new Date().getFullYear() - new Date(response.birth_date).getFullYear();

                if (user.user && ((user.user.slug === slug && user.user.account_type === 'jobseeker') || (user.user.account_type === 'employer' && user.user.active_subscription))) {
                    response.hidden = false;
                }
                else {
                }
                setJobseeker(response);
            })
            .catch((error) => {
                console.log(error);
            });
    }
    useEffect(() => {
        if (!user.loading) {
            if (slug) {
                getUserData(slug)
            } else if (location.pathname.includes('/profile')) {
                getUserData(user.user.slug)
            }
        }
    }, [slug, user]);
    let containerClasses = [styles.jobseeker_profile];
    let blurredBoxClasses = [];
    let last_seen = '';
    let is_online = false;

    if (jobseeker) {
        if (jobseeker.verification_status) {
            containerClasses.push(styles.jobseeker_profile_verified);
        }

        if (jobseeker.hidden) {
            containerClasses.push(styles.jobseeker_profile_hidden);
            blurredBoxClasses.push(styles.blurred);
        }

        const date_info = getTimeAgo(new Date(jobseeker.last_visit));

        if (date_info.unit_plural !== 'month' && date_info.unit_plural !== 'months' && date_info.unit_plural !== 'year' && date_info.unit_plural !== 'years') {

            if (date_info.unit_plural === 'second' || date_info.unit_plural === 'seconds' || date_info.unit_plural === 'minute' || (date_info.unit_plural === 'minutes' && date_info.count < 5)) {
                last_seen = t('general.UI.online');
                is_online = true;
            }
            else {
                last_seen = t('general.UI.last_seen') + ' ' + date_info.count + ' ' + t('general.UI.' + date_info.unit_plural) + ' ' + t('general.UI.ago');
            }

        }
    }
    const [activeTab, setActiveTab] = useState(0); // state to track the active tab
    useEffect(() => {
        const selectedProfileTab = localStorage.getItem('selectedProfileTab')
        setActiveTab(Number(selectedProfileTab))
    }, [])
    const tabs = [
        { name: 'personalInformation', icon: Profile },
        { name: 'contactDetails', icon: Contact },
        { name: 'workExperience', icon: WorkHistory },
        { name: 'education', icon: Mortarboard },
        { name: 'skills', icon: Idea },
        { name: 'occupations', icon: Idea },
        { name: 'jobPreferences', icon: Navigation },
        { name: 'resumeCoverLetter', icon: TaskDone },
        { name: 'certifications', icon: Certificate },
        { name: 'portfolio', icon: Folder },
        { name: 'account', icon: WorkHistory },

    ];

    useEffect(() => {
        if (user?.user?.slug === slug || location.pathname.includes('/profile')) {
            if (jobseeker) {
                const completion = calculateProfileCompletion(user.user);
                setCompletionPercentage(completion);
            }
        }
    }, [jobseeker]);

    // Function to get the active tab based on the URL path
    const getActiveTabFromPath = (path) => {
        const tabs = [`/profile/personal-information`,
            `/profile/contact-information`,
            `/profile/work-experience`,
            `/profile/education`,
            `/profile/skills`,
            `/profile/occupation`,
            `/profile/job-preferences`,
            `/profile/resume`,
            `/profile/certification`,
            `/profile/portfolio`,
            `/profile/account`
        ]
        // `/profile/company-information`,
        const tab = tabs.find(tab => path.includes(tab));
        return tab ? tabs.indexOf(tab) : 0;
    };

    // Update activeTab based on the URL path
    useEffect(() => {
        const path = location.pathname;
        const activeTabIndex = getActiveTabFromPath(path);
        setActiveTab(activeTabIndex);
    }, [location.pathname]);
    return (
        <>
            {user?.user?.slug === slug && user?.user?.account_type === 'jobseeker' || location.pathname.includes('/profile') ? (
                <div className={`${styles.container} ${styles.fcvRow}`}>
                    <ProfileSideBar activeTab={activeTab} setActiveTab={setActiveTab}
                    description2={jobseeker?.jobseeker_status == 'business' ? t('job_seeker.looking_for_company_job') : t('job_seeker.looking_for_house_worker_job')}
                    tabs={tabs} />
                    <div className={styles.editContainer}>
                        {completionPercentage < 100 && <CompleteProfile progress={completionPercentage} />}
                        {jobseeker?.verification_status == 'approved' ? <></> :
                            <GetVerifiedNotice />
                        }
                        {activeTab == 0 && jobseeker &&
                            <>
                                <AboutMeSection jobseeker={jobseeker} />
                                <PersonalInformation activeTab={activeTab} jobseeker={jobseeker} />
                            </>
                        }
                        {activeTab == 1 && <ContactDetail activeTab={activeTab} jobseeker={jobseeker} />}
                        {activeTab == 2 && <EditWorkExperience activeTab={activeTab} jobseeker={jobseeker} />}
                        {activeTab == 3 && <EditEducation activeTab={activeTab} jobseeker={jobseeker} />}
                        {activeTab == 4 &&
                            <>
                                <EditSkill activeTab={activeTab} jobseeker={jobseeker} />
                                <EditRoleBasedSkill activeTab={activeTab} jobseeker={jobseeker} />
                            </>
                        }
                        {activeTab == 5 && <EditOccupations activeTab={activeTab} jobseeker={jobseeker} />}
                        {activeTab == 6 && <JobPreferences activeTab={activeTab} jobseeker={jobseeker} />}
                        {activeTab == 7 && <EditResumeAndCoverLetter activeTab={activeTab} jobseeker={jobseeker} />}
                        {activeTab == 8 && <Certificates activeTab={activeTab} jobseeker={jobseeker} />}
                        {activeTab == 9 && <EditPortfolio activeTab={activeTab} jobseeker={jobseeker} />}
                        {activeTab === 10 && <Account activeTab={activeTab} employer={jobseeker} />}
                    </div>
                </div>
            ) : (
                <JobseekerProfileEmployerView jobseeker={jobseeker} />
            )}
        </>
    );
}

export default JobseekerProfile;